import React, { useEffect } from 'react';
import Paginations from '@material-ui/lab/Pagination';
import '../../scss/pagechange.scss';
import { useLocation} from "react-router-dom";

export default function Pagination({page, setPage, totalpage, HandleChange}) {
    const location = useLocation();

    useEffect(() => {
        var firstDot = document.getElementsByClassName('MuiPaginationItem-ellipsis')[0];
        if(firstDot && firstDot.innerHTML !== "......") {
            firstDot.innerHTML = "......";
        }
        var secondDot = document.getElementsByClassName('MuiPaginationItem-ellipsis')[1];
        if(secondDot && secondDot.innerHTML !== "......") {
            secondDot.innerHTML = "......";
        }
    }, [page])
    console.log(page)
    return (     
        <Paginations count={totalpage} 
            size = "small" 
            siblingCount = {0} 
            page = { Number(new URLSearchParams(location.search).has('page')) ? Number(new URLSearchParams(location.search).get('page')) : 1 }
            defaultPage = { Number(new URLSearchParams(location.search).has('page')) ? Number(new URLSearchParams(location.search).get('page')) : 1 }
            onChange = {(event, value) => HandleChange(value)} 
        /> 
    );
}
